import type {CarrierOption, ShopCarrierOptions} from '@/types/CarrierOption';
import {defineStore} from 'pinia';
import {readonly, ref} from 'vue';

export const useCarrierStore = defineStore('carriers', () => {
  const accountCarriers = ref<CarrierOption[]>([]);
  const shopCarriers = ref<ShopCarrierOptions>();

  const getAccountCarriers = () => {
    return readonly(accountCarriers);
  };

  const setAccountCarriers = (newCarriers: CarrierOption[]) => {
    accountCarriers.value = newCarriers;
  };

  const getShopCarriers = (shopId: number) => {
    if (!shopCarriers.value) {
      return [];
    }

    return shopCarriers.value[shopId] ?? [];
  };

  const setShopCarriers = (shopId: number, newCarriers: CarrierOption[]) => {
    if (!shopCarriers.value) {
      shopCarriers.value = {[shopId]: newCarriers};
      return;
    }

    shopCarriers.value[shopId] = newCarriers;
  };

  const updateShopCarrier = (shopId: number, carrierOption: Partial<CarrierOption>) => {
    if (!shopCarriers.value?.[shopId]) {
      return;
    }

    shopCarriers.value[shopId] = shopCarriers.value[shopId].map((contract) => {
      if (contract.id === carrierOption.id) {
        return {...contract, ...carrierOption};
      }

      return contract;
    });
  };

  const deleteShopCarrier = (shopId: number, contractId: number) => {
    if (!shopCarriers.value?.[shopId]) {
      return;
    }

    shopCarriers.value[shopId] = shopCarriers.value[shopId].filter((contract) => contract.id !== contractId);
  };

  return {
    getAccountCarriers,
    setAccountCarriers,
    getShopCarriers,
    setShopCarriers,
    updateShopCarrier,
    deleteShopCarrier,
    accountCarriers,
  };
});
